import React from 'react';

class DataColumnHeader extends React.Component {
    renderHeaderComponent() {
        if (!this.props.headerComponent) {
            return null;
        }

        return (
            <this.props.headerComponent />
        )
    }

    render () {
        return (
            <div {...this.props} className={['component-data-column-header', this.props.className].join(' ')}>
                { this.renderHeaderComponent() || this.props.text }
            </div>
        )
    }
}

export default DataColumnHeader;



// WEBPACK FOOTER //
// ./web-app/components/data-column-header.jsx